import { VideoEditor } from '../components/VideoEditor';

export default function VideoCartoonPage() {
  return <VideoEditor style="cartoon" />;
}
